"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.url = void 0;

var _utils = require("./utils.js");

var urlCollect = {
  // 开发环境
  dev: {
    mock: '/mock',
    url: '//bridge.api.xiaoyuanhao.com/debug'
  },
  // 测试环境
  test: {
    // mock: 'https://www.easy-mock.com/mock/5c0675b8a2222f2bf0a7b8af/nbugs-component-example',
    url: '//bridge.api.xiaoyuanhao.com/debug'
  },
  // 生产环境
  production: {
    url: '//bridge.api.xiaoyuanhao.com'
  }
};
var url = urlCollect[_utils.ENV];
exports.url = url;